/**
 * Status of a bank connection
 */
export enum BankStatementsStatus {
    Connected = 'connected',
    Available = 'available',
    Unsupported = 'unsupported',
    ErrorRepairable = 'error_repairable',
}

/**
 * Available connectors for checking resolvability
 */
interface AvailableConnectors {
    plaid: string;
    mx: string;
    finicity: string;
    akoya: string;
}

/**
 * Represents a bank statement availability item
 */
export interface BankStatementAvailabilityItem {
    id: number;
    status: BankStatementsStatus;
    apiName: string;
    apiAccountId: string;
    apiAccountName: string;
    apiOfficialName: string;
    apiAccountNo: string;
    apiInstitutionId: string;
    apiAccountType: string;
    apiSubType: string;
    glAccountId: number;
    autoClassify: string;
    defaultClientId: number;
    plaidItemId: number;
    syncTransactions: boolean;
    createdDate: string;
    connection_status: BankStatementsStatus;
    connector_id: string | null;
    connection_id: string | null;
    bank_account_name: string | null;
    available_connectors?: AvailableConnectors;
    error_repairable_at: string | null;
    /**
     * False at a bank whose Quiltt connections break too often to support. We offer neither a new
     * connection nor a repair there; a connection that works keeps syncing. Absent from older backends,
     * which offered both.
     */
    offer_auto_statements?: boolean;
}

/**
 * Response from the bank statements availability endpoint
 * The API returns an array of items directly rather than an object with an items property
 */
export type BankStatementsAvailabilityListResponse = BankStatementAvailabilityItem[];
